import React, {useState, useEffect} from "react";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    Input,
    Label,
    Modal,
    ModalBody,
    Offcanvas,
    OffcanvasBody,
    Row,
    UncontrolledDropdown,
    FormFeedback
} from 'reactstrap';

import BreadCrumb from "../../../Components/Common/BreadCrumb";


import {DatePicker, Pagination, Tag} from "antd";
import Select from "react-select";

import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CustomPagination from "../util/CustomPagination";
import ContactModal from "./ContactModal";
import ContactDetailModal from "./ContactDetailModal"; // Novo Modal de Detalhes
import CustomSelect from "../util/CustomSelect";
import dayjs from "dayjs";
// import "./assets/css/Contact.css";
import locale from "antd/es/date-picker/locale/pt_BR";
import {ToastContainer} from 'react-toastify';

const {RangePicker} = DatePicker;

const Contact = () => {
    document.title = "Help Desk | Plantão Rápido";

    const [contacts, setContacts] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [clearSelects, setClearSelects] = useState(false);
    const [priorities, setPriorities] = useState([]);
    const [sectors, setSectors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
    const [showContactDetailModal, setShowContactDetailModal] = useState(false); // Modal de Detalhes
    const [selectedContact, setSelectedContact] = useState(null); // Contato selecionado para detalhes
    const [pagination, setPagination] = useState({current: 1, pageSize: 5, total: 0});
    const [searchFilters, setSearchFilters] = useState({
        pagination: 5,
        dateRange: [],
        datestart: null,
        dateend: null,
        contacts_status_id: null,
        priority_id: null,
        sector_id: null,

    });
    useEffect(() => {
        fetchContacts(1);
        fetchData("list-status", setStatuses);
        fetchData("list-priority", setPriorities);
        fetchData("list-sectors", setSectors);
    }, []);

    const fetchData = async (endpoint, setter) => {
        setLoading(true);
        try {
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}contact/${endpoint}`, {}, true);
            const {data} = ApiService.handleApiResponse(response);
            setter(data || []);
        } catch (err) {

        } finally {
            setLoading(false);
        }
    };

    const fetchContactsStatus = async (contac) => {
        try {
            const param = {
                contact_id: contac.id,
                contacts_status_id: 3  // Novo status
            };

            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}contact/status`, param, true);

            if (response.code === 200) {
                const updatedContacts = contacts.map(contact => {
                    if (contact.id === contac.id) {
                        return {
                            ...contact,
                            contacts_status_id: 3,
                            status: {  // Atualiza o objeto `status` também, se existir
                                ...contact.status,
                                id: 3,
                                name: "Concluído"  // Ajuste o nome conforme o necessário
                            }
                        };
                    }
                    return contact;  // Mantém os contatos que não foram alterados
                });

                setContacts(updatedContacts);  // Atualiza o estado com os novos dados

                Swal.fire('Sucesso', 'Status atualizado para Concluído!', 'success');
            } else {
                Swal.fire('Erro', 'Falha ao atualizar o status.', 'error');
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    const fetchContacts = async (page = 1) => {
        setLoading(true);
        try {


            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}contact/list`,
                {
                    datestart: searchFilters.datestart,
                    dateend: searchFilters.dateend,
                    contacts_status_id: searchFilters.contacts_status_id,
                    priority_id: searchFilters.priority_id,
                    sector_id: searchFilters.sector_id,
                    page: page,
                    pagination: pagination?.pageSize || 5
                }, true);

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setContacts(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 5, total: 0});
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleRegister = () => {

        setShowContactModal(true);
    };

    const handleContactModalClose = (save = false) => {
        if(save) {
            fetchContacts(pagination.page);
        }


        setShowContactModal(false);


    };

    const handleContactDetailModalClose = (save = false) => {

        if(save) {
            fetchContacts(pagination.page);
        }
        setShowContactDetailModal(false);
        setSelectedContact(null);
    };

    const handleShowDetails = (contact) => {
        setSelectedContact(contact);
        setShowContactDetailModal(true);
    };

    const handleClearFilters = () => {
        setSearchFilters({
            dateRange: [],
            datestart: null,
            dateend: null,
            contacts_status_id: null,  // Usa null para limpar selects
            priority_id: null,         // Usa null para limpar selects
            sector_id: null,           // Usa null para limpar selects
        });

        // Limpa os selects
        setClearSelects(true);
        setTimeout(() => setClearSelects(false), 0);  // Redefine para false logo em seguida para permitir selecionar novamente
    };


    const handleSearchFiltersChange = (key, value) => {

        setSearchFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };


    return (
        <React.Fragment>
            <ToastContainer closeButton={false}/>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Help Desk" pageTitle="Configuração"/>
                    <Row>
                        <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Data Solicitação</label>
                                        <div className="form-control">
                                            <RangePicker
                                                style={{border: "none", boxShadow: "none"}}
                                                variant="outlined"
                                                locale={locale}
                                                format="DD/MM/YYYY"  // Mostra em DD/MM/YYYY na tela
                                                className="range-picker-custom"
                                                value={searchFilters.dateRange.length > 0 ? searchFilters.dateRange : null}
                                                onChange={(dates) => {
                                                    if (dates) {
                                                        handleSearchFiltersChange("dateRange", dates);
                                                        handleSearchFiltersChange("datestart", dayjs(dates[0]).format("YYYY-MM-DD"));
                                                        handleSearchFiltersChange("dateend", dayjs(dates[1]).format("YYYY-MM-DD"));
                                                    } else {
                                                        handleSearchFiltersChange("dateRange", []);
                                                        handleSearchFiltersChange("datestart", null);
                                                        handleSearchFiltersChange("dateend", null);
                                                    }
                                                }}
                                            />

                                        </div>
                                    </div>
                                </div>

                                <CustomSelect
                                    label="Situação"
                                    className="col-2"
                                    options={statuses}
                                    value={searchFilters.contacts_status_id}
                                    clear={clearSelects}
                                    onChange={(selected) => handleSearchFiltersChange("contacts_status_id", selected || null)}
                                />

                                <CustomSelect
                                    label="Prioridade"
                                    className="col-2"
                                    options={priorities}
                                    value={searchFilters.priority_id}
                                    clear={clearSelects}
                                    onChange={(selected) => handleSearchFiltersChange("priority_id", selected || null)}
                                />

                                <CustomSelect
                                    label="Setores"
                                    className="col-4"
                                    options={sectors}
                                    value={searchFilters.sector_id}
                                    clear={clearSelects}
                                    onChange={(selected) => handleSearchFiltersChange("sector_id", selected || null)}
                                />
                        <div className="col-md-12 d-flex justify-content-end">
                            <button type="button" className="btn  mr-1  me-2"
                                    onClick={() => handleClearFilters()}>
                                <i className="fa fa-eraser"></i> Limpar Filtros
                            </button>
                            <button type="button" className="btn btn-info mr-1  me-2" onClick={() => handleRegister()}><i
                                className="fa fa-plus"></i> Cadastrar
                            </button>
                            <button type="button" className="btn btn-success" onClick={() => fetchContacts(1)} disabled={loading}>
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status"
                                              aria-hidden="true"></span>
                                        Buscando...
                                    </>
                                ) : (
                                    <>
                                        <i className="fa fa-search me-1"></i> Buscar
                                    </>
                                )}
                            </button>
                        </div>
                    </Row>


                    <Row>


                        <div className="list-container mt-4">
                            {loading ? (
                                <Skeleton count={5} height={5}/>
                            ) : contacts.length > 0 ? (
                                contacts.map((contact) => (
                                    <Col lg={12} key={contact.id}>
                                        <Card className="mb-1 p-2 shadow-sm card-hover">
                                            <CardBody className="card-body d-flex justify-content-between align-items-center p-2">
                                                <div className="col-10 ">
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <strong className="doc-name">{contact.name}</strong>
                                                        </div>
                                                        <div className="col-4">
                                                            <strong>Email:</strong>
                                                           {contact.email}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <strong>Assunto:</strong> {contact.subject}
                                                        </div>
                                                        <div className="col-4">
                                                            <strong>PROTOCOLO:</strong> #{contact.id} - {dayjs(contact.created_at).locale("pt-br").format("DD/MM/YYYY HH:mm")}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center mb-2">
                                                        {contact.status &&
                                                            <Tag color="blue">{contact.status.name}</Tag>}
                                                        {contact.priority &&
                                                            <Tag color="red">{contact.priority.name}</Tag>}
                                                    </div>
                                                    <p>
                                                        <strong>Questionamento:</strong> <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: contact.message.length > 100
                                                                ? `${contact.message.slice(0, 100)}...`
                                                                : contact.message
                                                        }}/>
                                                    </p>

                                                </div>
                                                <div
                                                    className="col-2 doc-info-right ms-lg-auto text-end mt-3 mt-lg-0">
                                                    <div className="clinic-booking">
                                                        <div className="text-center w-100">
                                                            <h6 className="text-muted mb-1">
                                                                <i className="fa fa-message me-2"></i>
                                                                {contact.messages.length}
                                                            </h6>
                                                            <div className="row">
                                                                <button type="button"
                                                                    className="btn btn-outline-info mt-2 btn-sm"
                                                                    onClick={() => handleShowDetails(contact)}
                                                                >
                                                                    <i className="fa fa-info-circle"></i> Detalhes
                                                                </button>
                                                                {
                                                                    contact.contacts_status_id != 3 && (
                                                                        <button type="button"
                                                                            className="btn btn-primary mt-2 btn-sm"
                                                                            onClick={() => fetchContactsStatus(contact)}
                                                                        >
                                                                            <i className="fa fa-save"></i> Concluir
                                                                        </button>

                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <div className="alert alert-primary" role="alert">
                                    Nenhum contato encontrado.
                                </div>
                            )}
                        </div>

                        <CustomPagination
                            className="mt-4"
                            onChange={(page) => fetchContacts(page)}
                            pagination={pagination}
                        />


                        {showContactModal && (
                            <ContactModal
                                show={showContactModal}
                                onHide={handleContactModalClose}
                                select={{
                                    statuses: statuses,
                                    priorities: priorities,
                                    sectors: sectors,
                                }}
                            />
                        )}

                        {showContactDetailModal && selectedContact && (
                            <ContactDetailModal
                                show={showContactDetailModal}
                                onHide={handleContactDetailModalClose}
                                contact={selectedContact}
                            />
                        )}

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Contact;
